import React, { useState } from 'react';
import Button from '@/components/atomics/Button';
import styles from './BukaIsolirForm.module.scss';
import Icon from '@/components/atomics/Icons';

const className = 'buka-isolir-form';

type BukaIsolirFormProps = {
  onCancel?: () => void;
  onSubmit?: (data: { fileBase64?: string }) => void;
  loading?: boolean;
};

const BukaIsolirForm: React.FC<BukaIsolirFormProps> = ({
  onCancel, onSubmit, loading 
}) => {
  const [fileBase64, setFileBase64] = useState<string | undefined>();
  const [fileName, setFileName] = useState<string | undefined>();

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setFileName(file.name);
      const reader = new FileReader();
      reader.onload = (event) => {
        if (file.size > (2 * 1024 * 1024)) {
          alert(`File size exceeds the maximum limit of 2 MB.`);
          setFileBase64(undefined);
          setFileName(undefined);
          return;
        }
        setFileBase64(event.target?.result as string);
      };
      reader.readAsDataURL(file);
    } else {
      setFileBase64(undefined);
      setFileName(undefined);
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (onSubmit) onSubmit({ fileBase64 });
  };

  return (
    <form className={styles[className]} data-testid="isolirform"
      onSubmit={handleSubmit} style={{ minWidth: 320 }}>
      <h5>Untuk melanjutkan proses pembukaan isolir, silakan unggah bukti pembayaran Anda.</h5>
      <div className={styles[className + '__label']}>
        Bukti Transaksi
      </div>
      <label htmlFor="file-upload" style={{ marginTop: 16, display: 'block' }}>        
        <div className={styles[className + '__upload']}>
          {
            fileName ? fileName : (
              <span>Upload bukti dengan format PDF maksimal 2 MB</span>
            )
          }          
          <Icon data-testid="isolirform-button" name={fileBase64 ? 'Close' : 'Upload'}
            onClick={() => {
              if (fileBase64) {
                setFileBase64(undefined);
                setFileName(undefined);
              }
            }} />
        </div>
      </label>
      <input
        className={styles[className + '__input']}
        data-testid="isolirform-input"
        type="file"
        id="file-upload"
        accept=".pdf"
        required
        onChange={handleFileChange}
      />
      <div className={styles[className + '__buttons']}>
        <Button onClick={onCancel} variant="outline-secondary">
          Batal
        </Button>
        <Button disabled={!fileBase64} type="submit" variant="primary">
          Submit
        </Button>
      </div>
    </form>
  );
};

export default BukaIsolirForm;